"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _lodash = require("lodash");

var _store = require("../store");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var PageWrapper = function PageWrapper(props) {
  var _sites$siteID, _sites$siteID$editorO, _sites$siteID2, _sites$siteID2$editor;

  var sidebarActive = props.sidebarActive,
      loaded = props.loaded,
      locked = props.locked,
      template = props.template,
      children = props.children;

  var _ref4 = (0, _store.useStore)(),
      _ref5 = _slicedToArray(_ref4, 1),
      _ref5$ = _ref5[0],
      _ref5$$cmsState = _ref5$.cmsState,
      sites = _ref5$$cmsState.sites,
      siteID = _ref5$$cmsState.siteID,
      _ref5$$editorState = _ref5$.editorState,
      siteHasChanged = _ref5$$editorState.siteHasChanged,
      postHasChanged = _ref5$$editorState.postHasChanged; // We need the window width to calculate scaling


  var _ref6 = (0, _react.useState)(null),
      _ref7 = _slicedToArray(_ref6, 2),
      windowWidth = _ref7[0],
      setWindowWidth = _ref7[1];

  (0, _react.useEffect)(function () {
    setWindowWidth(window.innerWidth);
  }, []);
  (0, _react.useEffect)(function () {
    var debouncedHandleResize = (0, _lodash.debounce)(function () {
      setWindowWidth(window.innerWidth);
    }, 100);
    window.addEventListener('resize', debouncedHandleResize);
    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(Container, {
    loaded: loaded,
    locked: locked,
    sidebar: _objectSpread({
      active: sidebarActive
    }, sites === null || sites === void 0 ? void 0 : (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : (_sites$siteID$editorO = _sites$siteID.editorOptions) === null || _sites$siteID$editorO === void 0 ? void 0 : _sites$siteID$editorO.sidebar)
  }, /*#__PURE__*/_react.default.createElement(Inner, {
    loaded: loaded,
    locked: locked,
    sidebar: _objectSpread({
      active: sidebarActive
    }, sites === null || sites === void 0 ? void 0 : (_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : (_sites$siteID2$editor = _sites$siteID2.editorOptions) === null || _sites$siteID2$editor === void 0 ? void 0 : _sites$siteID2$editor.sidebar),
    windowWidth: windowWidth
  }, template ? /*#__PURE__*/_react.default.createElement(Content, {
    disableLinks: siteHasChanged || postHasChanged
  }, children) : /*#__PURE__*/_react.default.createElement("div", {
    id: "jam-cms"
  }, children)));
};

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref) {
  var loaded = _ref.loaded,
      locked = _ref.locked,
      _ref$sidebar = _ref.sidebar,
      style = _ref$sidebar.style,
      active = _ref$sidebar.active;
  return loaded && !locked && style === 'scale' && active && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      height: 100vh;\n    "])));
});

var Inner = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref2) {
  var loaded = _ref2.loaded,
      locked = _ref2.locked,
      _ref2$sidebar = _ref2.sidebar,
      style = _ref2$sidebar.style,
      active = _ref2$sidebar.active,
      position = _ref2$sidebar.position,
      width = _ref2$sidebar.width,
      windowWidth = _ref2.windowWidth;
  return loaded && !locked && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      ", "\n    "])), style === 'scale' ? active && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n            transform: ", ";\n            transform-origin: ", " top;\n          "])), windowWidth && "scale(".concat(1 - width / windowWidth, ")"), position === 'left' ? 'right' : 'left') : style === 'inline' ? (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n            width: ", ";\n            margin-left: ", ";\n            margin-right: ", ";\n          "])), active ? "calc(100% - ".concat(width, "px)") : '100%', position === 'left' && active ? "".concat(width, "px") : 0, position === 'right' && active ? "".concat(width, "px") : 0) : style === 'overflow' && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)([""]))));
});

var Content = _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n"])), function (_ref3) {
  var disableLinks = _ref3.disableLinks;
  return disableLinks && (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      a {\n        pointer-events: none !important;\n      }\n    "])));
});

var _default = PageWrapper;
exports.default = _default;